<template>
  <main
    id="fallback-page"
    class="h-100 w-100 d-flex flex-column align-items-center justify-content-center"
  >
    <div
      id="logo"
      :style="{
        backgroundImage: `url(${$whitelabel.assets.logos.large}) `,
      }"
      class="w-75"
    ></div>
    <div class="w-75 badge-col d-flex flex-column align-items-center">
      <a class="store-link mb-3" :href="$whitelabel.branding.googlePlayUrl">
        <img
          v-if="$store.state.locale === 'de'"
          draggable="false"
          alt="Jetzt bei Google Play"
          class="store-logo"
          src="@/assets/img/buttons/google-play-de.png"
        />
        <img
          v-else
          draggable="false"
          alt="Get it on Google Play"
          class="store-logo"
          src="@/assets/img/buttons/google-play-en.png"
        />
      </a>
      <a class="store-link" :href="$whitelabel.branding.appStoreUrl">
        <img
          v-if="$store.state.locale === 'de'"
          draggable="false"
          alt="Laden im App Store"
          class="store-logo"
          src="@/assets/img/buttons/app-store-de.svg"
        />
        <img
          v-else
          draggable="false"
          alt="Download on the App Store"
          class="store-logo"
          src="@/assets/img/buttons/app-store-en.svg"
        />
      </a>
    </div>
  </main>
</template>

<script>
import { sendReferral } from "@/API/general";

function detectOS() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("windows")) return "win";
  else if (userAgent.includes("android")) return "android";
  else if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
  else if (userAgent.includes("linux")) return "linux";
  else if (userAgent.includes("macintosh") || userAgent.includes("mac os"))
    return "mac";
  else return "other";
}
function getResolution() {
  const width = window.screen.width * window.devicePixelRatio;
  const height = window.screen.height * window.devicePixelRatio;
  const landscapeWidth = Math.max(width, height);
  const landscapeHeight = Math.min(width, height);
  return `${landscapeWidth}x${landscapeHeight}`;
}

export default {
  name: "FallBackPage",
  data() {
    return {
      intervalId: null,
      localStartapp: null,
    };
  },
  mounted() {
    let startapp = this.$route.query.startapp;
    if (startapp) {
      this.localStartapp = startapp;

      const os = detectOS();
      const resolution = getResolution();
      sendReferral({ parameter: startapp, os, resolution }).catch((err) => {
        console.error("Failed to send referral:", err);
      });
      // Redirect to app store based on OS
      if (os === "android") {
        window.location.href = this.$whitelabel.branding.googlePlayUrl;
      } else if (os === "ios") {
        window.location.href = this.$whitelabel.branding.appStoreUrl;
      } else {
        console.log("No app store redirect for OS:", os);
      }
    }
    this.winWidth();
    this.$store.commit("setIsPageLoading", false);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    winWidth: function () {
      this.intervalId = setInterval(() => {
        let w = window.innerWidth;
        if (w >= 1024) {
          this.$router.go(-1);
        } else return;
      }, 100);
    },
  },
};
</script>
<style scoped lang="scss">
$logo-width: 649px;
#fallback-page {
  #logo {
    min-height: 280px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .store-link {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px; /* Set a consistent height */
  }

  .store-logo {
    height: 100%; /* Match the parent's height */
    width: auto; /* Adjust width to maintain aspect ratio */
    object-fit: contain; /* Ensure content fits inside the container */
  }
}
</style>
